import React, { Component } from 'react';

class Cost extends Component {
    render() {
        return <div id="cost" />
    }
}

export default Cost;


// WEBPACK FOOTER //
// ./src/components/BI/General/Cost.js